import { Record } from 'immutable';
import Article from '../ArticleRecord';
const ArticleContent = Record({
  article: new Article(),
  error: undefined,
  hasBufferedChanges: false,
  hasLocalChanges: false,
  isUpdated: false,
  isUpdating: false,
  isPrePublishing: false,
  isPublishing: false,
  isRequesting: false,
  lastLoaded: null,
  lastEditTicks: null,
  updateErrorType: null,
  updatedUsername: null,
  sessionId: new Date().valueOf(),
  sessionUpdateId: 0
});
export default ArticleContent;